module.exports = __webpack_public_path__ + "img/book_2.c1c159fd.png";